export default "__VITE_ASSET__BiS5kJuw__"